import { IconPropsType } from '..';

export const ErrorCloseIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="6"
    height="6"
    viewBox="0 0 6 6"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 5.154L5.154 6L3 3.846L0.846 6L0 5.154L2.154 3L0 0.846L0.846 0L3 2.154L5.154 0L6 0.846L3.846 3L6 5.154Z"
      fill="#EA6161"
    />
  </svg>
);
